import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputDateUI from '../../../widgets/form/InputDateUI'
import InputSelectSF from '../../../widgets/form/InputSelectSF'

const UseOfProceedsCreateModalUI = ({ context, successMsg, errorList, setErrorList, messageList,
  // modes
  createMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
  // form fields
  vendorId, onVendorIdChange, vendorIdError, setVendorIdError,
  billName, onBillNameChange, billNameError, setBillNameError,
  billAmount, onBillAmountChange, billAmountError, setBillAmountError,
  chartOfAccountCode, onChartOfAccountCodeChange, chartOfAccountCodeError, setChartOfAccountCodeError,
  taxSlabCode, onTaxSlabCodeChange, taxSlabCodeError, setTaxSlabCodeError,
  dueDate, onDueDateChange, dueDateError, setDueDateError,
  notes, onNotesChange, notesError, setNotesError,
  taxSlabList, chartOfAccountList, vendorList
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Create Use Of Proceeds'
    buttonLabel='Create'
    cancelLabel='Cancel'
    isOpen={createMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputSelectSF type='text' name='vendorId' maxLength={12}
      label='Vendor Id'
      value={vendorId} onChange={onVendorIdChange}
      error={vendorIdError} setError={setVendorIdError}
      autoFocus={true} optionList={vendorList}

    />
    <InputTextSF type='text' name='billName' maxLength={12}
      label='Bill name'
      value={billName} onChange={onBillNameChange}
      error={billNameError} setError={setBillNameError}

    />
    <InputTextSF type='text' name='billAmount' maxLength={12}
      label='Bill amount'
      value={billAmount} onChange={onBillAmountChange}
      error={billAmountError} setError={setBillAmountError}
    />
    <InputSelectSF type='text' name='chartOfAccountCode' maxLength={12}
      label='Chart of account code'
      value={chartOfAccountCode} onChange={onChartOfAccountCodeChange}
      error={chartOfAccountCodeError} setError={setChartOfAccountCodeError} optionList={chartOfAccountList}
    />
    <InputSelectSF type='text' name='taxSlabCode' maxLength={12}
      label='Tax slab code'
      value={taxSlabCode} onChange={onTaxSlabCodeChange}
      error={taxSlabCodeError} setError={setTaxSlabCodeError} optionList={taxSlabList}
    />
    {/* <InputTextSF type='text' name='dueDate' maxLength={12}
      label='Due date'
      value={dueDate} onChange={ondueDateChange}
      error={dueDateError} setError={setdueDateError}
    /> */}
    <InputDateUI context={context} name='dueDate'
      messageList={messageList} label='Due date'
      selectedDateISO={dueDate} onChange={onDueDateChange}
      error={dueDateError} setError={setDueDateError}
    />
    <InputTextSF type='text' name='notes' maxLength={100}
      label='Notes'
      value={notes} onChange={onNotesChange}
      error={notesError} setError={setNotesError}
    />
  </ModalFormUI>

export default UseOfProceedsCreateModalUI
